
const brand = {
    electric: '#4F48F7',
    midnight: '#0F2449',
    moss: '#1C4372',
    sky: '#48A1F7',
    azure: '#89C9FF',
    lime: '#00D579',
    pink: '#C43DA0',
};

const secondBrand = {
    night: '#040D28',
    midnight: '#0F2449',
    dawn: '#1C4372',
    foam: '#4072A5',
}

const neutral = {
    1000: '#161C22',
    900: '#3D4449',
    800: '#5C666B',
    700: '#778086',
    600: '#9AA4AB',
    500: '#AEB8BE',
    400: '#C2CACF',
    300: '#D0D7DC',
    200: '#DCE3E7',
    100: '#E5EBEE',
    50: '#F0F4F7',
    bg: '#F7F9FB',
}

const transparent = {
   80: 'rgba(20, 29, 38, 0.8)',
    60: 'rgba(20, 29, 38, 0.6)',
    50: 'rgba(20, 29, 38, 0.5)',
    40: 'rgba(20, 29, 38, 0.4)',
    30: 'rgba(20, 29, 38, 0.3)',
    20: 'rgba(20, 29, 38, 0.2)',
    15: 'rgba(20, 29, 38, 0.15)',
    10: 'rgba(20, 29, 38, 0.1)',
    7: 'rgba(20, 29, 38, 0.07)',
    5: 'rgba(20, 29, 38, 0.05)',
}

export const v2colors = {
    brand,
    primary: {
        DEFAULT: 1000,
        1000: brand.electric,
        900: '#3327B7',
        800: '#4239E0',
        700: '#4F48F7',
        600: '#656CFF',
        500: '#7C8AFF',
        400: '#8F9FFF',
        300: '#A8B8FF',
        200: '#D0DAFF',
        100: '#E8ECFF',
    },
    secondBrand,
    neutral,
    transparent,
} as const;

